import React, { useEffect, useState } from "react"
import Moment from "react-moment";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { getPartnerAllCandidate, loadPartnerAllCandidate } from "../store/partner";
import PurchaseOrders from "../../Components/ApplicantProcessing/PurchaseOrders";
import BulkInvoice from "../../Components/ApplicantProcessing/BulkInvoice";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../store/tools";

export default function PartnerInvoices() {
    const route = [{ name: "Contract Management", url: "" }];

    const [candidateList, setCandidateList] = useState([]);
    const [candidateObj, setCandidateObj] = useState(null);
    const [poShowHide, setPoShowHide] = useState(false);
    const [bulkShowHide, setBulkShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const toolsCountSelector = useSelector(getToolsCount);

    const navigate = useNavigate();
    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPageTitle("Invoices and Payments"));
        dispatch(setCurrentRoute(route))
    }, [])

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));
    }, []);

    useEffect(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
            if (userDetailsSelector?.approved > 0)
                dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
        }
    }, [userDetailsSelector]);

    useEffect(() => {
        if (partnerAllCandidateSelector.length > 0) {
            setCandidateList(partnerAllCandidateSelector);
            let candItems = "";
            partnerAllCandidateSelector.map((x, key) => {
                if (key > 0) candItems += ",";
                candItems += x.performerid;
            });

            const appObj = toolsCountSelector.filter(x => x.key === 0);
            let appCiid = 0;
            if (appObj.length > 0)
                appCiid = appObj[0].value;

            handleUpdateComponent(candItems, appCiid);
        }
    }, [partnerAllCandidateSelector]);

    const handleCandidateInnoice = (item) => {
        navigate("/CandidateInvoice", { state: item });
    }

    const handlePoShowHide = (obj) => {
        setPoShowHide(!poShowHide);
        setCandidateObj(obj);
    };

    const handleBulkShowHide = () => {
        setBulkShowHide(!bulkShowHide);
    };

    const handleUpdateComponent = (compItems, ciid) => {
        const comp = componentUserStatusSelector.filter(x => x.compId === 23);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Partner Candidate Invoice",
            performerId: currentUser.id,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 23
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }

    const getPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
            //return getReadUnreadBgColor(50)
        }
        else {
            //return getReadUnreadBgColor(51)
        }

        let pcount = obj.poTypes.filter(x => x.type === poType && x.partnerSign !== true && x.sendStatus === true).length;
        if (pcount === 0) {
            pcount = obj.poTypes.filter(x => x.type === poType && x.sendStatus === true).length;
            return <span className="badge badge-pill badge-success position-absolute mt--2">
                {pcount}
            </span>
        } else {
            return <span className="badge badge-pill badge-danger position-absolute mt--2">
                {pcount}
            </span>
        }
    }

    return <React.Fragment>

        <div className="col-md-12 mt-2">
            <div className="card shadow-none border">
                <div className="card-header p-3">
                    <div className="row">
                        <div className="col-md-6">
                            {/* <i className="fa fa-square wf-phase6-box mr-2" ></i> */}
                            <span className="h3">
                                Invoices and Payments
                            </span>

                            <p className="text-black">
                                Click on Go to Invoices button to genenrate
                                monthly invoices for your candidates.
                            </p>
                        </div>
                        <div className="col-md-6 text-right">
                            <button
                                className="btn btn-sm btn-outline-default"
                                disabled={!appApproved}
                                onClick={handleBulkShowHide}
                            >
                                Option : Generate Monthly Bulk Invoices
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body p-3">
                    <div className="table-responsive">
                        <table className="table align-items-center table-flush table-hover table-striped border">
                            <thead className="thead-light">
                                <tr>
                                    <th>Candidate #<br />IPCS ID</th>
                                    <th>Details</th>
                                    <th>Agency</th>
                                    <th>Duration<br />(Start-End)</th>
                                    <th>Onboarding<br />Status</th>
                                    <th>Purchase Order</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {candidateList.map((item) => (
                                    <tr>
                                        <td>
                                            {item.performerid}
                                            <br />
                                            {item.maxloans}
                                        </td>
                                        <td>
                                            <span className="text-uppercase font-weight-bold">
                                                {item.performername} {item.lastName}
                                            </span>
                                            <br />
                                            {item.performeremail}
                                            <br />
                                            {item.contactNo && getFormatedNumber(item.contactNo)}
                                            <br />
                                            {getFieldData(
                                                item.performerData,
                                                "projectengagement",
                                                "PositionTitle"
                                            )}
                                        </td>
                                        <td>
                                            {getFieldData(
                                                item.performerData,
                                                "projectengagement",
                                                "AgencyName"
                                            )}
                                        </td>
                                        <td>
                                            {item.duration !== null && (
                                                <React.Fragment>
                                                    {item.duration.duration} Months
                                                    <br />
                                                    Start :{" "}
                                                    <Moment format="MMM Do YYYY">
                                                        {item.duration.startDate}
                                                    </Moment>
                                                    <br />
                                                    End :{" "}
                                                    <Moment format="MMM Do YYYY">
                                                        {item.duration.endDate}
                                                    </Moment>
                                                </React.Fragment>
                                            )}
                                        </td>
                                        <td>
                                            {item.appSubmit && (
                                                <span>
                                                    Complete
                                                </span>
                                            )}
                                            {!item.appSubmit && (
                                                <span>
                                                    Pending
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-link p-0"
                                                onClick={() => handlePoShowHide(item)}
                                            >
                                                View and eSign
                                                {/* {
                                                    item?.poSentCount === 0 ?
                                                        <span className="badge badge-pill badge-success position-absolute mt--2">
                                                            {item?.poSentCount}
                                                        </span> :
                                                        <span className="badge badge-pill badge-danger position-absolute mt--2">
                                                            {item?.poSentCount}
                                                        </span>
                                                } */}

                                                {getPoCount(item)}
                                            </button>
                                        </td>
                                        <td>
                                            <button
                                                onClick={() => handleCandidateInnoice(item)}
                                                className="btn btn-sm btn-link p-0"
                                            >
                                                Go To Invoices
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseOrders
            poShowHide={poShowHide}
            handlePoShowHide={handlePoShowHide}
            candidateObj={candidateObj}
        ></PurchaseOrders>
        <BulkInvoice
            bulkShowHide={bulkShowHide}
            handleBulkShowHide={handleBulkShowHide}
            candidateList={candidateList}
        ></BulkInvoice>
    </React.Fragment>
}